import React, { useState } from 'react';
import { Search, Filter, Clock, CheckCircle, XCircle, AlertCircle, User, Mail, Phone, Calendar, FileText, Eye, Check, X, Star, BookOpen, ChevronRight, ChevronDown } from 'lucide-react';

const NuevosTutores = () => {
  const [activeTab, setActiveTab] = useState('POR APROBAR PERFIL');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTutor, setSelectedTutor] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const tabs = [
    { id: 'POR APROBAR PERFIL', label: 'Por Aprobar Perfil', count: 8, color: 'blue' },
    { id: 'EXAMEN NO GENERADO', label: 'Examen No Generado', count: 3, color: 'orange' },
    { id: 'POR CALIFICAR', label: 'Por Calificar', count: 5, color: 'purple' },
    { id: 'TODOS', label: 'Todos', count: 16, color: 'gray' }
  ];

  const tutorCandidates = [
    {
      id: 1,
      name: "Franklyn Stevenn Pineda Vargas",
      phone: "573155754874",
      email: "franklynpineda.19@gmail.com",
      registrationDate: "2025-05-26",
      status: "POR APROBAR PERFIL",
      career: "INGENIERÍA INDUSTRIAL",
      university: "UNIVERSIDAD INDUSTRIAL DEL SANTANDER (UIS)",
      prospect: "PROSPECTO",
      progress: 25,
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      completedSections: ['Tipo de Servicios', 'Cédula'],
      pendingSections: ['Materias', 'Cuentas', 'Anexos', 'Foto perfil'],
      subjects: ['ÁLGEBRA LINEAL', 'CÁLCULO 1', 'CÁLCULO 2', 'FÍSICA 1', 'QUÍMICA'],
      examDetails: null,
      documents: ['Cédula', 'Diploma', 'Certificado de notas'],
      experience: "2 años de experiencia en tutorías particulares",
      motivation: "Quiero ayudar a estudiantes a superar las dificultades en matemáticas y física"
    },
    {
      id: 2,
      name: "Jose Gilberto Rendón",
      phone: "573003801575",
      email: "jilbertv@gmail.com",
      registrationDate: "2025-05-29",
      status: "EXAMEN NO GENERADO",
      career: "INGENIERÍA DE SISTEMAS",
      university: "UNIVERSIDAD DE ANTIOQUIA (UDEA)",
      prospect: "PROSPECTO",
      progress: 100,
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      completedSections: ['Materias', 'Cuentas', 'Tipo de Servicios', 'Anexos', 'Foto perfil', 'Cédula'],
      pendingSections: [],
      subjects: ['PROGRAMACIÓN', 'ALGORITMOS', 'ESTRUCTURAS DE DATOS', 'BASES DE DATOS'],
      examDetails: null,
      documents: ['Cédula', 'Diploma', 'Certificado de notas', 'Carta de recomendación'],
      experience: "3 años como desarrollador y 1 año dando clases",
      motivation: "Compartir conocimientos de programación con nuevas generaciones"
    },
    {
      id: 3,
      name: "Andrés Juan Bermúdez Zambrano",
      phone: "573003774242",
      email: "andresberzam@gmail.com",
      registrationDate: "2025-05-29",
      status: "POR CALIFICAR",
      career: "DERECHO",
      university: "UNIVERSIDAD SANTO TOMÁS",
      prospect: "PROSPECTO",
      progress: 100,
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      completedSections: ['Materias', 'Cuentas', 'Tipo de Servicios', 'Anexos', 'Foto perfil', 'Cédula'],
      pendingSections: [],
      subjects: ['DERECHO CIVIL', 'DERECHO PENAL', 'DERECHO CONSTITUCIONAL'],
      examDetails: {
        examDate: "2025-06-10",
        duration: "2 horas",
        questions: 25,
        status: "Completado - Pendiente de calificación"
      },
      documents: ['Cédula', 'Diploma', 'Certificado de notas', 'Tarjeta profesional'],
      experience: "5 años de experiencia profesional en derecho",
      motivation: "Enseñar fundamentos jurídicos a estudiantes de derecho"
    },
    {
      id: 4,
      name: "María Fernanda Gómez",
      phone: "573156789012",
      email: "mariafgomez@gmail.com",
      registrationDate: "2025-06-01",
      status: "POR APROBAR PERFIL",
      career: "QUÍMICA",
      university: "UNIVERSIDAD PONTIFICIA BOLIVARIANA",
      prospect: "PROSPECTO",
      progress: 60,
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      completedSections: ['Materias', 'Tipo de Servicios', 'Cédula'],
      pendingSections: ['Cuentas', 'Anexos', 'Foto perfil'],
      subjects: ['QUÍMICA ORGÁNICA', 'QUÍMICA INORGÁNICA', 'BIOQUÍMICA'],
      examDetails: null,
      documents: ['Cédula', 'Diploma'],
      experience: "1 año de experiencia en laboratorios",
      motivation: "Facilitar el aprendizaje de química a nivel universitario"
    }
  ];

  const filteredCandidates = tutorCandidates.filter(candidate => {
    const matchesSearch = candidate.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         candidate.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         candidate.career.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesTab = activeTab === 'TODOS' || candidate.status === activeTab;
    return matchesSearch && matchesTab;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case 'POR APROBAR PERFIL': return 'blue';
      case 'EXAMEN NO GENERADO': return 'orange';
      case 'POR CALIFICAR': return 'purple';
      default: return 'gray';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'POR APROBAR PERFIL': return <AlertCircle className="w-4 h-4" />;
      case 'EXAMEN NO GENERADO': return <Clock className="w-4 h-4" />;
      case 'POR CALIFICAR': return <FileText className="w-4 h-4" />;
      default: return <User className="w-4 h-4" />;
    }
  };

  const CandidateCard = ({ candidate }) => (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-4">
            <img 
              src={candidate.avatar} 
              alt={candidate.name}
              className="w-16 h-16 rounded-full border-4 border-gray-100"
            />
            <div>
              <h3 className="font-bold text-lg text-gray-900">{candidate.name}</h3>
              <p className="text-blue-600 font-medium text-sm">{candidate.career}</p>
              <p className="text-gray-500 text-xs">{candidate.university}</p>
            </div>
          </div>
          <div className="flex flex-col items-end space-y-2">
            <span className={`px-3 py-1 rounded-full text-xs font-semibold bg-${getStatusColor(candidate.status)}-100 text-${getStatusColor(candidate.status)}-800 flex items-center gap-1`}>
              {getStatusIcon(candidate.status)}
              {candidate.status}
            </span>
            <span className="text-xs text-gray-500">{candidate.registrationDate}</span>
          </div>
        </div>

        <div className="mb-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-gray-700">Progreso del registro</span>
            <span className="text-sm font-bold text-blue-600">{candidate.progress}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div 
              className={`bg-${getStatusColor(candidate.status)}-500 h-2 rounded-full transition-all duration-300`}
              style={{ width: `${candidate.progress}%` }}
            ></div>
          </div>
        </div>

        <div className="space-y-3 mb-4">
          <div className="flex items-center text-sm text-gray-600">
            <Phone className="w-4 h-4 mr-2 text-green-500" />
            <span>{candidate.phone}</span>
          </div>
          <div className="flex items-center text-sm text-gray-600">
            <Mail className="w-4 h-4 mr-2 text-blue-500" />
            <span className="truncate">{candidate.email}</span>
          </div>
          <div className="flex items-center text-sm text-gray-600">
            <BookOpen className="w-4 h-4 mr-2 text-purple-500" />
            <span>{candidate.subjects.length} materias registradas</span>
          </div>
        </div>

        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">Estado de secciones:</h4>
          <div className="space-y-1">
            {candidate.completedSections.map((section, index) => (
              <div key={index} className="flex items-center text-xs text-green-600">
                <CheckCircle className="w-3 h-3 mr-2" />
                <span>{section}</span>
              </div>
            ))}
            {candidate.pendingSections.map((section, index) => (
              <div key={index} className="flex items-center text-xs text-red-600">
                <XCircle className="w-3 h-3 mr-2" />
                <span>{section}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex gap-2">
          <button 
            onClick={() => {
              setSelectedTutor(candidate);
              setShowDetails(true);
            }}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center text-sm font-semibold"
          >
            <Eye className="w-4 h-4 mr-2" />
            Ver Detalles
          </button>
          {candidate.status === 'POR APROBAR PERFIL' && (
            <button className="bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-lg transition-colors duration-200">
              <Check className="w-4 h-4" />
            </button>
          )}
          {candidate.status === 'EXAMEN NO GENERADO' && (
            <button className="bg-orange-600 hover:bg-orange-700 text-white py-2 px-3 rounded-lg transition-colors duration-200">
              <FileText className="w-4 h-4" />
            </button>
          )}
          <button className="bg-red-600 hover:bg-red-700 text-white py-2 px-3 rounded-lg transition-colors duration-200">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );

  const DetailModal = ({ candidate, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src={candidate.avatar} 
                alt={candidate.name}
                className="w-20 h-20 rounded-full border-4 border-gray-100"
              />
              <div>
                <h2 className="text-2xl font-bold text-gray-900">{candidate.name}</h2>
                <p className="text-blue-600 font-medium">{candidate.career}</p>
                <p className="text-gray-500 text-sm">{candidate.university}</p>
              </div>
            </div>
            <button 
              onClick={onClose}
              className="bg-gray-100 hover:bg-gray-200 p-2 rounded-full transition-colors duration-200"
            >
              <X className="w-6 h-6 text-gray-600" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Información Personal</h3>
              <div className="space-y-2 text-sm">
                <p><span className="font-medium">Teléfono:</span> {candidate.phone}</p>
                <p><span className="font-medium">Email:</span> {candidate.email}</p>
                <p><span className="font-medium">Fecha de registro:</span> {candidate.registrationDate}</p>
                <p><span className="font-medium">Estado:</span> 
                  <span className={`ml-2 px-2 py-1 rounded-full text-xs bg-${getStatusColor(candidate.status)}-100 text-${getStatusColor(candidate.status)}-800`}>
                    {candidate.status}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Progreso de Registro</h3>
              <div className="mb-3">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-gray-700">Completado</span>
                  <span className="text-sm font-bold text-blue-600">{candidate.progress}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div 
                    className="bg-blue-500 h-3 rounded-full transition-all duration-300"
                    style={{ width: `${candidate.progress}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Materias a Enseñar</h3>
            <div className="flex flex-wrap gap-2">
              {candidate.subjects.map((subject, index) => (
                <span key={index} className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">
                  {subject}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Documentos</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {candidate.documents.map((doc, index) => (
                <div key={index} className="flex items-center p-2 bg-gray-50 rounded-lg">
                  <FileText className="w-4 h-4 mr-2 text-gray-600" />
                  <span className="text-sm text-gray-700">{doc}</span>
                </div>
              ))}
            </div>
          </div>

          {candidate.examDetails && (
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Detalles del Examen</h3>
              <div className="bg-purple-50 p-4 rounded-lg">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                  <div>
                    <span className="font-medium text-gray-700">Fecha:</span>
                    <p className="text-purple-600">{candidate.examDetails.examDate}</p>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">Duración:</span>
                    <p className="text-purple-600">{candidate.examDetails.duration}</p>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">Preguntas:</span>
                    <p className="text-purple-600">{candidate.examDetails.questions}</p>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">Estado:</span>
                    <p className="text-purple-600">{candidate.examDetails.status}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Experiencia y Motivación</h3>
            <div className="space-y-3">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-700 mb-1">Experiencia:</h4>
                <p className="text-gray-600 text-sm">{candidate.experience}</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium text-gray-700 mb-1">Motivación:</h4>
                <p className="text-gray-600 text-sm">{candidate.motivation}</p>
              </div>
            </div>
          </div>

          <div className="flex gap-4 pt-4 border-t border-gray-200">
            <button className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg transition-colors duration-200 font-semibold">
              Aprobar Candidato
            </button>
            <button className="flex-1 bg-orange-600 hover:bg-orange-700 text-white py-3 px-6 rounded-lg transition-colors duration-200 font-semibold">
              Generar Examen
            </button>
            <button className="flex-1 bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-lg transition-colors duration-200 font-semibold">
              Rechazar
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">DUFY ASESORÍAS - 2.0</h1>
              <p className="text-gray-600 mt-1">Gestión de Nuevos Tutores</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors duration-200 font-semibold">
                Invitar Tutor
              </button>
              <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition-colors duration-200 font-semibold">
                Exportar Reporte
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Stats Overview */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          {tabs.slice(0, 3).map((tab, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-md">
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-sm font-medium text-gray-500">{tab.label}</h3>
                <div className={`w-3 h-3 bg-${tab.color}-500 rounded-full`}></div>
              </div>
              <p className={`text-3xl font-bold text-${tab.color}-600`}>{tab.count}</p>
              <p className="text-xs text-gray-500 mt-1">candidatos</p>
            </div>
          ))}
          <div className="bg-white p-6 rounded-xl shadow-md">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-medium text-gray-500">Total Registros</h3>
              <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
            </div>
            <p className="text-3xl font-bold text-gray-600">16</p>
            <p className="text-xs text-gray-500 mt-1">este mes</p>
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-lg mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors duration-200 ${
                    activeTab === tab.id
                      ? `border-${tab.color}-500 text-${tab.color}-600`
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {tab.label}
                  <span className={`ml-2 px-2 py-1 rounded-full text-xs font-semibold ${
                    activeTab === tab.id
                      ? `bg-${tab.color}-100 text-${tab.color}-800`
                      : 'bg-gray-100 text-gray-600'
                  }`}>
                    {tab.count}
                  </span>
                </button>
              ))}
            </nav>
          </div>

          {/* Search Bar */}
          <div className="p-6">
            <div className="relative">
              <Search className="absolute left-4 top-4 h-5 w-5 text-gray-400" />
              <input
                type="text"
                placeholder="Buscar candidatos por nombre, email o carrera..."
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="mb-6">
          <p className="text-gray-600">
            Mostrando <span className="font-semibold text-blue-600">{filteredCandidates.length}</span> candidatos
            {searchTerm && <span> para "{searchTerm}"</span>}
          </p>
        </div>

        {/* Candidates Grid */}
        {filteredCandidates.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCandidates.map(candidate => (
              <CandidateCard key={candidate.id} candidate={candidate} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="bg-white rounded-2xl shadow-lg p-12 max-w-md mx-auto">
              <User className="mx-auto h-16 w-16 text-gray-400 mb-6" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">No se encontraron candidatos</h3>
              <p className="text-gray-600">Ajusta los filtros o términos de búsqueda para ver más resultados.</p>
            </div>
          </div>
        )}
      </div>

      {/* Detail Modal */}
      {showDetails && selectedTutor && (
        <DetailModal 
          candidate={selectedTutor} 
          onClose={() => {
            setShowDetails(false);
            setSelectedTutor(null);
          }} 
        />
      )}
    </div>
  );
};

export default NuevosTutores;